<template>
  <div id="dinamica">
    <section v-if="comenzo == false && page == 0">
      <div class="bannerprincipal">
        <div class="container">
          <div class="row">
            <div class="col-8 offset-2 col-md-4 offset-md-4 text-center">
              <img
                class="img-fluid"
                src="../assets/imgs/raspaygana/raspa-y-gana.png"
                alt="Raspa y Gana"
              />
            </div>

            <div
              class="
                col-10
                offset-1
                col-lg-6
                offset-lg-3
                text-center
                p-5
                bgazul
                rounded
              "
            >
              <!-- <img
            src="../assets/imgs/instrucciones/cronometro.png"
            alt="cronometro"
          /> -->

              <p class="blanco fG pt-4 pb-4">
                RESPONDE NUESTRA TRIVIA Y
                <span class="bold">DESCUBRE TU PREMIO</span> AL INSTANTE.
              </p>

              <img
                class="img-fluid py-3"
                src="../assets/imgs/raspaygana/instrucciones.png"
                alt="instrucciones"
              />

              <p class="blanco fG pt-4 pb-4">
                Selecciona la respuesta correcta
                <span class="bold">"raspando"</span> la pantalla y revela tu
                premio, tienes <span class="bold">20 segundos</span> para hacerlo.
              </p>

              <button
                @click="initJuego()"
                class="
                  my-5
                  amarillo
                  btnaction
                  pointer
                  d-flex
                  align-items-center
                  justify-content-center
                  btnaction
                  fG
                  ml-auto
                  mr-auto
                  w-100
                "
              >
                INICIAR
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="juego" class=""  v-if="comenzo == true && page == 0">
      <div class="container">
        <div class="row">


          <div class="col-8 offset-2 col-md-4 offset-md-4 text-center">
              <img
                class="img-fluid"
                src="../assets/imgs/raspaygana/raspa-y-gana.png"
                alt="Raspa y Gana"
              />
            </div>

            <div
              class="
                col-10
                offset-1
                col-md-10
                offset-md-1
                text-center
                p-5
                bgazul
                rounded
              "
            >


            <div class="time text-center blanco pt-3 fG bold">
              Tiempo
            </div>
            <div class="time text-center blanco pb-3 fG bold">
              {{time_txt}}
            </div>

            <div class="pregunta pb-5 blanco fG" v-if="pregunta != null">
              {{pregunta.pregunta}}
            </div>

            <p class="blanco">
              (Rasca una opción hasta descubrirla por completo y pulsa el boton "Continuar" para avanzar)
            </p>

            <div class="opciones" v-if="pregunta != null">


              <div class="sc__wrapper mb-4" id="sc__wrapper1">
                  <div class="respuesta fG active">
                    <span id="respuesta1">{{pregunta.r1}}</span>
                  </div>
                  <!-- scratchcard -->
                  <div id="js--sc--container" class="sc__container" ref="sccontainer">
                      <!-- background image insert here by scratchcard-js -->
                      <!-- canvas generate here -->
                  </div>
                  <!-- infos -->
                  
              </div>


              <div class="sc__wrapper mb-4" id="sc__wrapper2">
                  <div class="respuesta fG active">
                    <span id="respuesta2">{{pregunta.r2}}</span>
                  </div>
                  <!-- scratchcard -->
                  <div id="js--sc--container2" class="sc__container" ref="sccontainer2">
                      <!-- background image insert here by scratchcard-js -->
                      <!-- canvas generate here -->
                  </div>
                  <!-- infos -->
                  
              </div>

              <div class="sc__wrapper mb-4" id="sc__wrapper3">
                  <div class="respuesta fG active">
                    <span id="respuesta3">{{pregunta.r3}}</span>
                  </div>
                  <!-- scratchcard -->
                  <div id="js--sc--container3" class="sc__container" ref="sccontainer3">
                      <!-- background image insert here by scratchcard-js -->
                      <!-- canvas generate here -->
                  </div>
                  <!-- infos -->
                  
              </div>



            </div>

            <div class="row" v-if="mostrarAvanzar && form.id_premio != undefined && form.id_premio != null">
              <div class="col-12 py-4">
                <button
                  @click="siguiente()"
                  class="
                    btnaction
                    pointer
                    d-flex
                    align-items-center
                    justify-content-center
                    btnaction
                    fG
                    ml-auto
                    mr-auto
                    w-100
                    bold
                  "
                >
                  CONTINUAR
                </button>
              </div>
            </div>


            </div>

            

        </div>

       
      </div>
    </section>

    <section id="juego" class=""  v-if="page == 1">
    
      <div class="bannerprincipal">
        <div class="container">
          <div class="row">
            <div class="col-8 offset-2 col-md-4 offset-md-4 text-center">
              <img
                class="img-fluid"
                src="../assets/imgs/raspaygana/raspa-y-gana.png"
                alt="Raspa y Gana"
              />
            </div>

            <div
            v-if="overlayGanador"
              class="
                col-10
                offset-1
                col-lg-6
                offset-lg-3
                text-center
                p-5
                bgazul
                rounded
              "
            >
             
              <p class="blanco fXG pt-4 pb-4">
                ¡Felicidades <br>
                <span class="bold amarillo">{{userProfile.nombre}}</span>!
              </p>
              <p>
              <img
                class="img-fluid py-3"
                src="../assets/imgs/raspaygana/avion.png"
                alt="enviar"
              />
              </p>


              <p class="blanco fG pt-4 pb-2">
                Validaremos tu ticket de compra y en breve <span class="bold">nos comunicaremos contigo</span> para informarte los siguientes pasos.
              </p>

              <p class="fG pt-4 pb-2">
                <span class="amarillo bold">
                  Premio:
                </span>
                <br>
                <span class="bold amarillo">
                  {{ this.form.tipo_premio }}
                </span>
              </p>

              <router-link
                to="/mis-participaciones"
                class="
                  my-5
                  amarillo
                  btnaction
                  pointer
                  d-flex
                  align-items-center
                  justify-content-center
                  btnaction
                  fG
                  ml-auto
                  mr-auto
                  w-100
                "
              >
                FINALIZAR
              </router-link>
            </div>


            <div
            v-if="overlayPerdedor"
              class="
                col-10
                offset-1
                col-lg-6
                offset-lg-3
                text-center
                p-5
                bgazul
                rounded
              "
            >
             
              <p class="blanco fXG pt-4 pb-4">
                Lo sentimos <br>
                <span class="bold amarillo">{{userProfile.nombre}}</span>.
              </p>
              

              
              <p class="blanco fG pt-4 pb-4">
                Tu respuesta es incorrecta. Registra otro ticket para seguir participando.
              </p>

              <router-link
                to="/mis-participaciones"
                class="
                  my-5
                  amarillo
                  btnaction
                  pointer
                  d-flex
                  align-items-center
                  justify-content-center
                  btnaction
                  fG
                  ml-auto
                  mr-auto
                  w-100
                "
              >
                FINALIZAR
              </router-link>
            </div>

            <div
            v-if="overlayPerdedorCorrecta"
              class="
                col-10
                offset-1
                col-lg-6
                offset-lg-3
                text-center
                p-5
                bgazul
                rounded
              "
            >
             
              <p class="blanco fXG pt-4 pb-4">
                Lo sentimos <br>
                <span class="bold amarillo">{{userProfile.nombre}}</span>.
              </p>
              

              
              <p class="blanco fG pt-4 pb-4">
                Tu respuesta es correcta, sin embargo se han agotado los premios para esta semana, registra otro ticket para seguir participando.
              </p>

              <router-link
                to="/mis-participaciones"
                class="
                  my-5
                  amarillo
                  btnaction
                  pointer
                  d-flex
                  align-items-center
                  justify-content-center
                  btnaction
                  fG
                  ml-auto
                  mr-auto
                  w-100
                "
              >
                FINALIZAR
              </router-link>
            </div>


            <div
            v-if="overlayPerdedorGanoAnteriormente"
              class="
                col-10
                offset-1
                col-lg-6
                offset-lg-3
                text-center
                p-5
                bgazul
                rounded
              "
            >
             
              <p class="blanco fXG pt-4 pb-4">
                Lo sentimos <br>
                <span class="bold amarillo">{{userProfile.nombre}}</span>.
              </p>
              

              
              <p class="blanco fG pt-4 pb-4">
                Ya has ganado un premio esta semana, registra otro ticket la semana siguiente para seguir participando.
              </p>

              <router-link
                to="/mis-participaciones"
                class="
                  my-5
                  amarillo
                  btnaction
                  pointer
                  d-flex
                  align-items-center
                  justify-content-center
                  btnaction
                  fG
                  ml-auto
                  mr-auto
                  w-100
                "
              >
                FINALIZAR
              </router-link>
            </div>



          </div>
        </div>
      </div>



    </section>

    <Footer></Footer>

    
  </div>
</template>

<script>
import { commentsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import AOS from "aos";
import swal from "sweetalert2";

import Footer from "@/components/Footer";

import { ScratchCard, SCRATCH_TYPE } from "scratchcard-js";

import fitty from "fitty";

const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const TIEMPO_PARTICIPACION = 20;
const MAX_MATCHES = 35;
const MAX_NOMATCHES = 45;
const MAX_COCACINEPOLIS = 20;
const MAX_TARJETAS = MAX_MATCHES + MAX_COCACINEPOLIS + MAX_NOMATCHES;

export default {
  components: {
    Footer
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      isRunning: false,
      time: 0,
      time_init: 0,
      time_txt: TIEMPO_PARTICIPACION,
      ahora: moment(),
      indice: 0,
      respuesta_actual: null,
      puntos: 0,
      respuestas: {
        res: [],
        correctas: 0,
      },
      termino: false,
      comenzo: false,
      standBy: false,
      disponibles: [
      ],
      dulceria: [
      ],
      siluetas: [
      ],
      preguntas: [
         {
            "pregunta": "¿Cuántos kilos tiene un saco de Cemento Chihuahua?",
            "r1": "50 kg",
            "r2": "35 kg",
            "r3": "45 kg",
            "rc": "a",
            "ru ": ""
          },
          {
              "pregunta": "¿Es lo mismo el Cemento que el Concreto?",
              "r1": "Sí",
              "r2": "No",
              "r3": "Más o menos",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿Es lo mismo la grava y la arena?",
              "r1": "Sí",
              "r2": "No",
              "r3": "No sé",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿En qué diferencias la grava de la arena?",
              "r1": "En el tamaño",
              "r2": "En el color",
              "r3": "En nada",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuáles son los ingredientes para elaborar concreto?",
              "r1": "Cemento, grava, arena y agua",
              "r2": "Cemento y agua",
              "r3": "Cemento y arena",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Cómo sabes que un cemento es de calidad?",
              "r1": "Porque está certificado",
              "r2": "Cumple con todas las especificaciones",
              "r3": "Por las pruebas",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿El saco de Cemento dice el peso del contenido?",
              "r1": "Sí",
              "r2": "Solo en algunos sacos",
              "r3": "No está visible",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Qué es mejor, el concreto hecho en obra o el concreto premezclado GCC?",
              "r1": "El concreto GCC tiene la mayor calidad",
              "r2": "El concreto hecho en obra tiene muchas variaciones",
              "r3": "El concreto hecho en obra puede generar varios problemas",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Por qué compra Cemento Chihuahua?",
              "r1": "Porque es de aquí",
              "r2": "Porque es el de mejor calidad",
              "r3": "Porque lo necesito",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿Es fácil comprar Cemento Chihuahua?",
              "r1": "Sí, lo consigo en cualquier ferretería",
              "r2": "No ",
              "r3": "A veces",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Van a sacar el año que entra Cemento Chihuahua en saco de 25 kg?",
              "r1": "Sí",
              "r2": "No",
              "r3": "Quien sabe",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "Colores del logotipo de Cemento Chihuahua:",
              "r1": "Rojo y azul",
              "r2": "Rojo, azul y negro",
              "r3": "Azul y negro",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuántos años tiene Cemento Chihuahua?",
              "r1": "180",
              "r2": "80",
              "r3": "25",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿El saco de Cemento Chihuahua es reciclable?",
              "r1": "Sí",
              "r2": "No",
              "r3": "solo los de 25 kg",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿En qué presentación se vende el Cemento Chihuahua?",
              "r1": "En pipa y Saco de 50 kg",
              "r2": "Saco de 50 kg, Megabolsa de 2 toneladas y en pipa",
              "r3": "Saco de 50 kg y Megabolsa de 2 toneladas",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿La Megabolsa de Cemento Chihuahua es reutilizable?",
              "r1": "No",
              "r2": "Sí",
              "r3": "Se tira",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿Para que usa el Cemento Chihuahua?",
              "r1": "Para pegar bloques de concreto",
              "r2": "Para hacer la mezcla de concreto",
              "r3": "Todas las anteriores",
              "rc": "c",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuales son las propiedades del Cemento Chihuahua?",
              "r1": "Es resistente",
              "r2": "Durable",
              "r3": "Todas la anteriores",
              "rc": "c",
              "ru ": ""
          },
          {
              "pregunta": "¿Qué es mejor la grava triturada o la grava de río?",
              "r1": "De río",
              "r2": "Triturada",
              "r3": "Ambas",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuál es el tiempo máximo que puedo almacenar el saco de Cemento Chihuahua?",
              "r1": "1 mes",
              "r2": "2 meses",
              "r3": "3 meses ",
              "rc": "c",
              "ru ": ""
          },
          {
              "pregunta": "¿Cómo se deben almacenar el cemento?",
              "r1": "Bajo techo y libre de humedad",
              "r2": "En el patio al aire libre",
              "r3": "Lejos del piso",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Cemento Chihuahua ofrece asistencia técnica?",
              "r1": "Próximamente",
              "r2": "No ",
              "r3": "Sí, en asistec@gcc.com",
              "rc": "c",
              "ru ": ""
          },
          {
              "pregunta": "¿Qué premios nacionales ha ganado Cemento Chihuahua?",
              "r1": "Tecnología y exportación",
              "r2": "Ninguno",
              "r3": "De calidad, tecnología y exportación.",
              "rc": "c",
              "ru ": ""
          },
          {
              "pregunta": "¿Cemento Chihuahua tiene compromisos para la reducción de emisiones en sus Plantas?",
              "r1": "Sí tiene",
              "r2": "Está pensando en tenerlos",
              "r3": "A lo mejor tiene",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿A Cemento Chihuahua lo fabrica una empresa Socialmente Responsable?",
              "r1": "Si, GCC tiene 17 años consecutivos acreditado con el distintivo de Empresa Socialmente Responsable",
              "r2": "Si, GCC tiene 10 años consecutivos acreditado con el distintivo de Empresa Socialmente Responsable.",
              "r3": "Si, GCC tiene 5 años consecutivos acreditado con el distintivo de Empresa Socialmente Responsable.",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuál es la meta para el 2030 de reducción de emisiones en las plantas de GCC?",
              "r1": "22%",
              "r2": "15%",
              "r3": "18%",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuántas plantas producen Cemento Chihuahua en el Estado de Chihuahua?",
              "r1": "1",
              "r2": "2",
              "r3": "3",
              "rc": "c",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuál fue la primera Planta de Cemento Chihuahua en el Estado?",
              "r1": "Planta Juárez",
              "r2": "Planta Chihuahua",
              "r3": "Planta Samalayuca",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿El Cemento Chihuahua garantiza que el peso del saco sea correcto?",
              "r1": "Sí, con una triple verificación en su proceso de envasado.",
              "r2": "Sí, con una verificación en su proceso de envasado.",
              "r3": "Sí, con una doble verificación en su proceso de envasado.",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuántos sacos de Cemento Chihuahua tiene una tarima completa?",
              "r1": "20",
              "r2": "30",
              "r3": "45",
              "rc": "c",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuántos sacos de 50 kg tiene una tonelada de Cemento Chihuahua?",
              "r1": "45 sacos",
              "r2": "20 sacos",
              "r3": "5 sacos",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuántos kilos tiene una tonelada de Cemento Chihuahua?",
              "r1": "1,000 kg",
              "r2": "100 kg",
              "r3": "10 kg",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuántos kilos tiene una Megabolsa de Cemento Chihuahua?",
              "r1": "200 kg",
              "r2": "1000 kg",
              "r3": "2000 kg",
              "rc": "c",
              "ru ": ""
          },
          {
              "pregunta": "¿En que año inició operaciones la 1ra Planta de Cemento Chihuahua?",
              "r1": "2010",
              "r2": "1840",
              "r3": "1941",
              "rc": "c",
              "ru ": ""
          },
          {
              "pregunta": "¿Para elaborar el Cemento Chihuahua las Plantas transforman residuos industriales en energía?",
              "r1": "Sí, con el compromiso de reducción de emisiones coprocesan residuos y generan energía protegiendo al ambiente.",
              "r2": "Sí, cualquier residuo.",
              "r3": "Sí, solo llantas.",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Las Plantas donde se elabora el Cemento Chihuahua tienen viveros para reforestar?",
              "r1": "Sí, en Chihuahua y Cd Juárez.",
              "r2": "Sí, en Chihuahua",
              "r3": "Sí, en Cd. Juárez",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuántos sacos de Cemento Chihuahua equivalente a una Megabolsa?",
              "r1": "20 sacos",
              "r2": "40 sacos",
              "r3": "30 sacos",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿Dónde puede  revisar el proporcionamiento para mezclas hechas en obra?",
              "r1": "En la factura",
              "r2": "En el reverso del saco de Cemento Chihuahua",
              "r3": "En el saco de Cemento Chihuahua",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuánto es el tiempo máximo puede almacenar una megabolsa de Cemento Chihuahua?",
              "r1": "3 meses",
              "r2": "15 días",
              "r3": "2 meses",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Para hacer una mezcla de concreto cual es principal característica de la arena y la grava?",
              "r1": "Que sean del mismo color",
              "r2": "Que estén limpios que no sea tierra y libres de materia orgánica",
              "r3": "Que sea revuelto.",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿En qué unidad se vende el concreto premezclado?",
              "r1": "En toneladas",
              "r2": "En metros cúbicos",
              "r3": "En kilos",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "¿Cómo se mide la resistencia del concreto?",
              "r1": "Saltando sobre él",
              "r2": "Por resistencia a la compresión",
              "r3": "Por resistencia al impacto del camión",
              "rc": "b",
              "ru ": ""
          },
          {
              "pregunta": "Entre más agua agregues a la mezcla del concreto, obtendrás:",
              "r1": "Menos resistencia",
              "r2": "Mas resistencia",
              "r3": "Una mezcla aguada",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuándo el concreto recién ha endurecido, que tiene que hacer?",
              "r1": "Echarle agua para curarlo",
              "r2": "Ponerle lumbre",
              "r3": "Dejarlo que se seque",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Cuándo se presentan temperaturas menores a 5 grados centígrados y que no vaya a subir, puede vaciar la mezcla de concreto?",
              "r1": "No",
              "r2": "Sí",
              "r3": "Quien sabe",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿En tiempo de calor cómo protejo mi concreto?",
              "r1": "Lo curo con agua y lo tapo.",
              "r2": "Coloco un enfriador cerca.",
              "r3": "No cuelo durante el verano.",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿En tiempo de frío como evito que se congele mi concreto?",
              "r1": "Procuro colar temprano para que pueda fraguar y lo tapo.",
              "r2": "Le pongo un calentón.",
              "r3": "Lo preparo con agua caliente.",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "¿Debo tener cuidados cuando vacío mi concreto y hace mucho viento?",
              "r1": "Sí",
              "r2": "No",
              "r3": "No sé",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "Si hago mi concreto con pala ¿cómo debo preparar la superficie?",
              "r1": "Utilizando una artesa para prepararlo",
              "r2": "Barriendo con la escoba",
              "r3": "Aplanándola bien.",
              "rc": "a",
              "ru ": ""
          },
          {
              "pregunta": "Para hacer el concreto en máquina revolvedora ¿cuál es el orden para añadir los materiales?",
              "r1": "Grava, algo de agua, arena, cemento, resto del agua",
              "r2": "Agua, cemento, arena y grava.",
              "r3": "Cemento, algo de agua, grava, arena, resto del agua.",
              "rc": "a",
              "ru ": ""
          },


      ],
      pregunta: null,
      respuesta: null,

      disponibles_temp: [],
      dulceria_temp: [],
      matches_final: [],
      matches: [],
      nomatches: [],
      preguntas_listas: false,
      indice_pregunta: 0,
      rascado: false,
      sc: null,
      sc2: null,
      sc3: null,
      form: {
        res: "",
        pregunta: null,
        ganador: false,
        tiempo: null
      },
      page: 0,
      overlayGanador: false,
      overlayPerdedor: false,
      overlayPerdedorCorrecta: false,
      overlayPerdedorGanoAnteriormente: false,
      mostrarAvanzar: false,
      
      textoPerdedor: "Oops, tu respuesta es incorrecta.",
      textoPerdedorCorrecta: "Tu respuesta es correcta, pero se han agotado los premios para esta semana.",
      textoGanador: `<p><b class='bold'>¡Felicidades!</b></p><p>Tu respuesta es correcta.</p>`,
      premio: null
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
      disable: "mobile",
    });

    //this.construyePreguntas();


    //seleccionar pregunta 

    

    this.seleccionaPregunta();
    
    
  },
  methods: {
    initCards(){

      let thes = this;
      

      //const scContainer = this.$refs.sccontainer;

      //primer tarjeta
      let txt1 = this.textoPerdedor;
      if(this.pregunta.rc == 'a'){
        txt1 = this.textoGanador;
      }

      const scContainer = document.getElementById('js--sc--container')
      //console.log({scContainer})
      //const scInfos = document.querySelector('.sc__infos');
        this.sc = new ScratchCard('#js--sc--container', {
        scratchType: SCRATCH_TYPE.LINE,
        containerWidth: scContainer.offsetWidth,
        containerHeight: 150,
        brushSrc: '',
        imageForwardSrc: require('../assets/imgs/raspaygana/scratchcard.png'),
        imageBackgroundSrc: '',
        htmlBackground: `<div class="inner_html"><p>${txt1}</p></div>`,
        clearZoneRadius: 50,
        nPoints: 50,
        pointSize: 4,
        callback: function () {
          //alert('Now the window will reload !')
          //window.location.reload()

          //enviar a la pantalla de felicidades si respuesta correcta

          //si respuesta es incorrecta mandar a pantalla de agradecimiento
          
          thes.mostrarAvanzar = true;

        }
      })

      // Init
      this.sc.init().then(() => {
        this.sc.canvas.addEventListener('scratch.move', () => {

          if(this.rascado === false){
            thes.rascado = true;
            thes.disableT23();
          }
            

          let percent = thes.sc.getPercent().toFixed(0);
          //scInfos.innerHTML = percent + '%';
          //console.log(percent)
        })
      }).catch((error) => {
        // image not loaded
        //alert(error.message);
      });


      //segunda tarjeta

      let txt2 = this.textoPerdedor;
      if(this.pregunta.rc == 'b'){
        txt2 = this.textoGanador;
      }

      const scContainer2 = document.getElementById('js--sc--container2')
      //console.log({scContainer})
      //const scInfos = document.querySelector('.sc__infos');
      this.sc2 = new ScratchCard('#js--sc--container2', {
        scratchType: SCRATCH_TYPE.LINE,
        containerWidth: scContainer2.offsetWidth,
        containerHeight: 150,
        brushSrc: '',
        imageForwardSrc: require('../assets/imgs/raspaygana/scratchcard.png'),
        imageBackgroundSrc: '',
        htmlBackground: `<div class="inner_html"><p>${txt2}</p></div>`,
        clearZoneRadius: 50,
        nPoints: 50,
        pointSize: 4,
        callback: function () {
          //alert('Now the window will reload !')
          //window.location.reload()

          //enviar a la pantalla de felicidades si respuesta correcta

          //si respuesta es incorrecta mandar a pantalla de agradecimiento

          thes.mostrarAvanzar = true;
        }
      })

      // Init
      this.sc2.init().then(() => {
        this.sc2.canvas.addEventListener('scratch.move', () => {

          if(this.rascado === false){
            thes.rascado = true;
            thes.disableT13();
          }
            

          let percent = thes.sc2.getPercent().toFixed(0);
          //scInfos.innerHTML = percent + '%';
          //console.log(percent)
        })
      }).catch((error) => {
        // image not loaded
        //alert(error.message);
      });

      //tercera tarjeta
      let txt3 = this.textoPerdedor;
      if(this.pregunta.rc == 'c'){
        txt3 = this.textoGanador;
      }
      const scContainer3 = document.getElementById('js--sc--container3')
      //console.log({scContainer})
      //const scInfos = document.querySelector('.sc__infos');
      this.sc3 = new ScratchCard('#js--sc--container3', {
        scratchType: SCRATCH_TYPE.LINE,
        containerWidth: scContainer3.offsetWidth,
        containerHeight: 150,
        brushSrc: '',
        imageForwardSrc: require('../assets/imgs/raspaygana/scratchcard.png'),
        imageBackgroundSrc: '',
        htmlBackground: `<div class="inner_html"><p>${txt3}</p></div>`,
        clearZoneRadius: 50,
        nPoints: 50,
        pointSize: 4,
        callback: function () {
          //alert('Now the window will reload !')
          //window.location.reload()
          
          //enviar a la pantalla de felicidades si respuesta correcta

          //si respuesta es incorrecta mandar a pantalla de agradecimiento

          thes.mostrarAvanzar = true;
        }
      })

      // Init
      this.sc3.init().then(() => {
        this.sc3.canvas.addEventListener('scratch.move', () => {

          if(this.rascado === false){
            thes.rascado = true;
            thes.disableT12();
          }

          let percent = thes.sc3.getPercent().toFixed(0);
          //scInfos.innerHTML = percent + '%';
          //console.log(percent)
        })
      }).catch((error) => {
        // image not loaded
        //alert(error.message);
      });





    },
    disableT23(){
      console.log('disabling 23');

      this.form.res = 'a';
      

      this.sc2.canvas.removeEventListener('sratch.move', () => {});
      this.sc3.canvas.removeEventListener('sratch.move', () => {});

      document.getElementById('respuesta1').innerHTML = '';
      document.getElementById('js--sc--container2').innerHTML = '';
      document.getElementById('js--sc--container3').innerHTML = '';

      //enviar participacion y quitar id_ultimo_ticket

      this.enviaRespuesta();

    },
    disableT13(){
      console.log('disabling 13');

      this.form.res = 'b';

      this.sc.canvas.removeEventListener('sratch.move', () => {});
      this.sc3.canvas.removeEventListener('sratch.move', () => {});

      document.getElementById('respuesta2').innerHTML = '';
      document.getElementById('js--sc--container').innerHTML = '';
      document.getElementById('js--sc--container3').innerHTML = '';

      //enviar participacion y quitar id_ultimo_ticket

      this.enviaRespuesta();


    },
    disableT12(){
      console.log('disabling 12');

      this.form.res = 'c';

      this.sc.canvas.removeEventListener('sratch.move', () => {});
      this.sc2.canvas.removeEventListener('sratch.move', () => {});

      document.getElementById('respuesta3').innerHTML = '';
      document.getElementById('js--sc--container').innerHTML = '';
      document.getElementById('js--sc--container2').innerHTML = '';

      //enviar participacion y quitar id_ultimo_ticket

      this.enviaRespuesta();


      
    },
    terminaTiempo(){
      console.log('disabling 123');

      this.form.res = '';

      this.sc.canvas.removeEventListener('sratch.move', () => {});
      this.sc2.canvas.removeEventListener('sratch.move', () => {});
      this.sc3.canvas.removeEventListener('sratch.move', () => {});

      document.getElementById('js--sc--container').innerHTML = '';
      document.getElementById('js--sc--container2').innerHTML = '';
      document.getElementById('js--sc--container3').innerHTML = '';

      //enviar participacion y quitar id_ultimo_ticket

      this.enviaRespuesta();


      
    },
    seleccionaPregunta(){
      let temp = [...this.preguntas];
      temp = this.shuffle(temp);

      this.pregunta = temp.pop();

      let thes = this;

      
      
      
    },
    resizeOpciones(){
      setTimeout(function (){
        let fitties = fitty('.respuesta span', {
          maxSize: 30
        });
        // console.log("🚀 ~ file: Dinamica.vue ~ line 490 ~ fitty", {fitty})
        // console.log("🚀 ~ file: Dinamica.vue ~ line 493 ~ fitties", {fitties});
        
        fitties[0].fit();
       

      }, 10);
    },
    seleccionaOpcion(respuesta) {
      //console.log(respuesta)

      if (this.isRunning === true) {
        this.disponibles_temp[this.indice_pregunta].eleccion = respuesta;

        if (this.indice_pregunta + 1 < this.disponibles_temp.length) {
          this.indice_pregunta++;
        } else {
          //todo: anadir que no se pueda dar más de un click
          this.terminarJuego();
        }
      }
    },
    construyePreguntas() {
      this.resetDisponibles();

      this.disponibles_temp.forEach((pregunta) => {
        //primera opcion
        pregunta.opciones.push(pregunta.silueta);
        //segunda opcion
        pregunta = this.agregaSiluetaOpciones(pregunta);
        //tercera opcion
        pregunta = this.agregaSiluetaOpciones(pregunta);

        pregunta.opciones = this.shuffle(pregunta.opciones);
      });

      //console.log({preguntas: this.disponibles_temp})

      this.preguntas_listas = true;
    },
    agregaSiluetaOpciones(pregunta) {
      let index = Math.floor(Math.random() * this.siluetas.length) + 1;
      index--;
      while (pregunta.opciones.includes(this.siluetas[index].silueta)) {
        index = Math.floor(Math.random() * this.siluetas.length) + 1;
        index--;
      }

      pregunta.opciones.push(this.siluetas[index].silueta);

      return pregunta;
    },
    construyeMatches() {
      this.resetDisponibles();
      this.resetDulceria();

      for (var i = 0; i < MAX_MATCHES; i++) {
        let obj;
        obj = this.getNext("match");
        this.matches_final.push(obj);
      }
      for (i = 0; i < MAX_NOMATCHES; i++) {
        let obj;
        obj = this.getNext("nomatch");
        this.matches_final.push(obj);
      }
      for (i = 0; i < MAX_COCACINEPOLIS; i++) {
        let obj;
        // obj = {
        //   opcion1: "cocacinepolis",
        //   opcion2: "cocacinepolis",
        // };
        obj = this.getNext("dulceria");
        this.matches_final.push(obj);
      }

      this.matches_final = this.shuffle(this.matches_final);
    },
    resetDisponibles() {
      this.disponibles_temp = [...this.siluetas];
      this.disponibles_temp = this.shuffle(this.disponibles_temp);
      //console.log({ reset: this.disponibles_temp });
    },
    resetDulceria() {
      this.dulceria_temp = [...this.dulceria];
      this.dulceria_temp = this.shuffle(this.dulceria_temp);
    },
    getNext(tipo) {
      var obj = {
        opcion1: "",
        opcion2: "",
      };

      var temp;
      //console.log({ temp: temp[0] });

      switch (tipo) {
        case "match":
          temp = this.disponibles_temp.splice(0, 1);
          obj.opcion1 = obj.opcion2 = temp[0];
          break;
        case "dulceria":
          temp = this.dulceria_temp.splice(0, 1);
          obj.opcion1 = obj.opcion2 = temp[0];
          break;
        case "nomatch":
          temp = this.disponibles_temp.splice(0, 1);
          obj.opcion1 = temp[0];
          obj.opcion2 = this.getDiferente(obj.opcion1);
          break;
      }

      //      console.log({lengthdisponibles: this.disponibles_temp})
      if (this.disponibles_temp.length == 0) this.resetDisponibles();
      if (this.dulceria_temp.length == 0) this.resetDulceria();

      return obj;
    },
    getDiferente() {
      let rand = Math.floor(Math.random() * this.disponibles.length) + 0;
      return this.disponibles[rand];
    },
    match(respuesta) {
      let thes = this;
      //console.log({ match: respuesta });
      let evaluacion = this.matches_final[this.indice];
      let correcta = false;

      if (evaluacion.opcion1 === evaluacion.opcion2) {
        correcta = true;
      }

      if (respuesta === correcta) {
        this.puntos++;
        if (correcta === true) this.animarCorazon();
      }

      this.indice++;
      if (this.matches_final.length === this.indice) this.terminarJuego();

      this.standBy = true;
      setTimeout(thes.releaseStandBy, 800);
    },
    releaseStandBy() {
      this.standBy = false;
    },
    animarCorazon() {
      // let corazon = this.$refs.corazon;
      // let svg = document.createElement("span");
      // svg.innerHTML = `<svg
      //                 ref=""
      //                 width="40"
      //                 class="ml-2 mt-n2 animado"
      //                 enable-background="new 0 0 24 24"
      //                 id="Layer_1"
      //                 version="1.0"
      //                 viewBox="0 0 24 24"
      //                 xml:space="preserve"
      //                 xmlns="http://www.w3.org/2000/svg"
      //                 xmlns:xlink="http://www.w3.org/1999/xlink"
      //               >
      //                 <path
      //                   fill="#e11616"
      //                   d="M16.4,4C14.6,4,13,4.9,12,6.3C11,4.9,9.4,4,7.6,4C4.5,4,2,6.5,2,9.6C2,14,12,22,12,22s10-8,10-12.4C22,6.5,19.5,4,16.4,4z"
      //                 />
      //               </svg>`;

      // corazon.appendChild(svg);

      let svg2 = document.createElement("span");
      svg2.innerHTML = `<svg
                      ref=""
                      width="100"
                      class="ml-2 mt-n2 animado"
                      enable-background="new 0 0 24 24"
                      id="Layer_1"
                      version="1.0"
                      viewBox="0 0 24 24"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <path
                        fill="#e11616"
                        d="M16.4,4C14.6,4,13,4.9,12,6.3C11,4.9,9.4,4,7.6,4C4.5,4,2,6.5,2,9.6C2,14,12,22,12,22s10-8,10-12.4C22,6.5,19.5,4,16.4,4z"
                      />
                    </svg>`;
      let corazon2 = this.$refs.corazon2;
      corazon2.appendChild(svg2);

      // let corazon1 = document.querySelector(".animado");
      // corazon1.classList.remove("animar");

      setTimeout(function () {
        let corazones = document.querySelectorAll(".animado");
        corazones.forEach((element) => {
          element.classList.add("animar");
        });
      }, 10);
    },
    initJuego() {
      let thes = this;
      this.comenzo = true;
      this.isRunning = true;
      this.startTimer();

      this.resizeOpciones();

      setTimeout(function(){
        thes.initCards();
      },200)
    },
    shuffle(array) {
      array.sort(() => Math.random() - 0.5);
      return array;
    },
    async startTime() {
      var thes = this;
      this.time_init = this.$store.getters.timeInit;
      //console.log("start time");
      //console.log({ timeinit: this.time_init });
      if (this.time_init == null || this.time_init == 0) {
        this.time_init = moment();
        this.$store.dispatch("setTimeInit").then(
          (response) => {
            thes.time_init = thes.$store.getters.timeInit;
            const ahora = moment();
            thes.time = ahora.diff(thes.time_init, "seconds");
            //console.log({segundos: thes.time})
          },
          (error) => {
            console.log(error);
          }
        );
      }
      this.startTimer();
    },
    startTimer() {
      if (this.isRunning === true) {
        //console.log({ timeinit: this.time_init });
        const ahora = moment();
        //this.time = ahora.diff(this.time_init, "seconds");
        this.time  = 0;
        //console.log({ time: this.time });
        this.interval = setInterval(this.incrementTime, 1000);
      }
    },
    incrementTime() {
      if (this.isRunning === true) {
        this.time = parseInt(this.time) + 1;
        this.time_txt = parseInt(TIEMPO_PARTICIPACION) - parseInt(this.time);

        if(this.time_txt.toString().length == 1 ){
          this.time_txt = "0" + this.time_txt.toString();
        }

        //console.log({time: this.time})


        if (this.time >= 20) {
          //this.terminarJuego();
          
          this.terminaTiempo();
        }
      }
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    terminarJuego() {
      //console.log("terminar juego");
      this.termino = true;
      this.isRunning = false;

      //this.$store.state.loading =  true;
      this.$store.dispatch("showLoader", true);

      //registro bd
      const https = require("https");

      var qData = {
        email: this.userProfile.email,
      };

      // // // this.$http
      // // //   .post(
      // // //     process.env.VUE_APP_API_URL + "envio-participacion.php",
      // // //     JSON.stringify(qData),
      // // //     {
      // // //       emulateJSON: true,
      // // //       httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      // // //       headers: {
      // // //         "Content-Type": "text/plain",
      // // //         //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
      // // //       },
      // // //     }
      // // //   )
      // // //   .then(
      // // //     (response) => {
      // // //       // get body data

      // // //       console.log("res login");
      // // //       console.log(response);

      // // //       let res = response.body;

      // // //       if (res.status == "ok") {
      // // //         //
      // // //       } else {
      // // //         //
      // // //       }
      // // //     },
      // // //     (error) => {
      // // //       // error callback
      // // //       this.$store.dispatch("showLoader", false);
      // // //       console.log("error callback");
      // // //       console.log(error);
      // // //     }
      // // //   );

      //registro firebase
      qData = {
        time_txt: this.time_txt,
        time: this.time,
        puntos: this.evalua(),
        respuestas: this.disponibles_temp,
      };
      this.$store.dispatch("registraTrivia", qData);
    },
    evalua() {
      let puntos = 0;
      this.disponibles_temp.forEach((pregunta) => {
        if (pregunta.eleccion == pregunta.silueta) {
          puntos += 100;
        }
      });
      return puntos;
    },
    async enviaRespuesta() {

      console.log('enviando')

      this.isRunning =  false;
      

      //this.$store.dispatch("showLoader", true);

      const https = require("https");

      //console.log("🚀 ~ file: Dinamica.vue ~ line 882 ~ enviaRespuesta ~ userProfile", this.userProfile);
      if (
        this.userProfile.user_id == "" ||
        this.userProfile.user_id == undefined ||
        this.userProfile.user_id == null
      ) {
        swal.fire(
          "Oops",
          "Ha ocurrido un error en el envío de tu respuesta, por favor recarga la página y vuelve a intentarlo.",
          "warning"
        );
        return;
      }

      var qData = this.form;
      qData.userId = this.userProfile.user_id;
      qData.email = this.userProfile.email;
      qData.respuesta_pregunta = this.pregunta.rc;
      qData.pregunta = this.pregunta;
      
      this.form.tiempo = this.time;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "rp.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            console.log("res rp");
            console.log(response);

            let res = response.body;
            this.$store.dispatch("showLoader", false);

            

            if (res.status == "ok" && res.ganador == "1") {

              this.form.ganador = res.ganador;
              this.form.id_premio = res.id_premio;
              this.form.tipo_premio = res.tipo_premio;
              this.form.respuesta_correcta = res.respuesta_correcta;
              this.form.fecha_redimido = res.fecha_redimido;
              this.form.semana_a_entregar = res.semana;

              await this.$store.dispatch("registraParticipacion", this.form);
              this.overlayGanador = true;
              this.mostrarAvanzar = true;
              
            } else if (res.status == "ok" && res.ganador == "0" && res.respuesta_correcta == "0") {

              this.form.ganador = res.ganador;
              this.form.id_premio = res.id_premio;
              this.form.tipo_premio = res.tipo_premio;
              this.form.respuesta_correcta = res.respuesta_correcta;
              this.form.fecha_redimido = res.fecha_redimido;
              this.form.semana_a_entregar = res.semana;

              await this.$store.dispatch("registraParticipacion", this.form);
              this.overlayPerdedor = true;
              this.mostrarAvanzar = true;
            
            } else if (res.status == "ok" && res.ganador == "0" && res.respuesta_correcta == "1" && res.ya_gano_en_la_semana == "1") {

              this.form.ganador = res.ganador;
              this.form.id_premio = res.id_premio;
              this.form.tipo_premio = res.tipo_premio;
              this.form.respuesta_correcta = res.respuesta_correcta;
              this.form.fecha_redimido = res.fecha_redimido;
              this.form.semana_a_entregar = res.semana;

              await this.$store.dispatch("registraParticipacion", this.form);
              this.overlayPerdedorGanoAnteriormente = true;
              this.mostrarAvanzar = true;
            
            } else if (res.status == "ok" && res.ganador == "0" && res.respuesta_correcta == "1" && res.ya_gano_en_la_semana == "0") {

              this.form.ganador = res.ganador;
              this.form.id_premio = res.id_premio;
              this.form.tipo_premio = res.tipo_premio;
              this.form.respuesta_correcta = res.respuesta_correcta;
              this.form.fecha_redimido = res.fecha_redimido;
              this.form.semana_a_entregar = res.semana;

              await this.$store.dispatch("registraParticipacion", this.form);
              this.overlayPerdedorCorrecta = true;
              this.mostrarAvanzar = true;
            
            } else if (res.status == "notok") {
              //bloqueo por ip

              
             
              swal.fire(
                "Oops",
                res.msg,
                "warning"
              );



            } else {
              //
              swal.fire(
                "Oops",
                "Ha ocurrido un error en el envío de tu respuesta, por favor recarga la página y vuelve a intentarlo.",
                "warning"
              );
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    siguiente(){
      this.page ++;
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
